import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';

const QuoteWidget = ({ text, containerSettings }) => (
  <Container settings={containerSettings}>
    <div className="container">
      <div className="blockquote-wrapper">
        <div className="shift-two-cols">
          <blockquote className="text-container">{text}</blockquote>
        </div>
      </div>
    </div>
  </Container>
);

QuoteWidget.title = 'Quote';
QuoteWidget.preview = 'quote.png';
QuoteWidget.category = 'Content';

QuoteWidget.propTypes = {
  text: PropTypes.string.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

QuoteWidget.defaults = {
  text: 'Във въздуха се носеше нежното и игриво бръмчене на комар, електрическото жужене на оса, скрита, приютена в нейното специално топло розово гнездо. Музиката бе достатъчно силна, за да може и той да долови мелодията.',
  containerSettings: {},
};

QuoteWidget.adminFields = {
  text: { type: 'textarea' },
};

export default QuoteWidget;
